(function() {
  
  (() => {
    const megaMenus = document.querySelectorAll('details.mega-menu');
    const transparentHeader = document.querySelector('.header-transparent');
    var mouseInTarget;
    
    megaMenus.forEach((item, i) => {
      document.body.addEventListener('mouseover', (evt) => mouseInTarget = evt.target, false);
      document.body.addEventListener('focusin', (evt) => mouseInTarget = evt.target, false);
      
      item.addEventListener('mouseover', handleOnHover.bind(this, item), false);
      item.addEventListener('focusin', handleOnHover.bind(this, item), false);
    
      item.addEventListener('mouseout', handleHoverOut.bind(this, item));
      item.addEventListener('focusout', handleHoverOut.bind(this, item));
    });
    
    function handleOnHover (item, evt) {
      item.setAttribute('data-mouse-over', '');
      setTimeout(() => {
        if (item.hasAttribute('data-mouse-over')) item.setAttribute('open', '');
        toggleTranparentHeader(item);
      }, 250);
    }
    
    function handleHoverOut (item, evt) {
      // console.log('mouse out');
      
      // console.log(evt.type);
      // console.log(evt.target);
      
      var targetParents = getParents(item);
      // console.log(targetParents);
      // console.log(targetParents.indexOf(item));
      // console.log(targetParents.indexOf(item) < 0);
      setTimeout(() => {
        var mouseInTargetParents = getParents(mouseInTarget);
        // console.log('mouseInTarget', mouseInTarget);
        // console.log('mouseInTarget', mouseInTargetParents);
        if (mouseInTarget != item && mouseInTargetParents.indexOf(item) < 0) {
          // console.log('really hover out !');
          item.removeAttribute('data-mouse-over');
          item.removeAttribute('open');
          toggleTranparentHeader(item);
        }
      }, 30);

    }
    
    function toggleTranparentHeader (item) {
      if (!transparentHeader) return;
      if (item.hasAttribute('open')) {
        transparentHeader.classList.remove('header-transparent');
      } else {
        transparentHeader.classList.add('header-transparent');
      }
    }
    
    var getParents = function (elem) {
    
    	// Set up a parent array
    	var parents = [];
    
    	// Push each parent element to the array
    	for ( ; elem && elem !== document; elem = elem.parentNode ) {
    		parents.push(elem);
    	}
    
    	// Return our parent array
    	return parents;
    
    };
  })();
  
})()
